export const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
export const CONTRACT_ADDRESS_COINFLIP = process.env.REACT_APP_CONTRACT_ADDRESS_COINFLIP;